/**
 * Command Palette state (P2.1-S4).
 *
 * Global Cmd/Ctrl+K hiển thị palette overlay. Single-instance cho toàn app.
 */
import { create } from "zustand";

interface CommandPaletteState {
  open: boolean;
  query: string;
  openPalette: () => void;
  closePalette: () => void;
  togglePalette: () => void;
  setQuery: (q: string) => void;
}

export const useCommandPaletteStore = create<CommandPaletteState>((set) => ({
  open: false,
  query: "",
  openPalette: () => set({ open: true }),
  closePalette: () => set({ open: false, query: "" }),
  togglePalette: () => set((s) => ({ open: !s.open, query: s.open ? "" : s.query })),
  setQuery: (q) => set({ query: q }),
}));
